import React from 'react';

import { Box, Grid } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const gridStylesSmall = cssMap({
	root: {
		width: '100%',
		gridTemplateColumns: '1fr 223px',
		gap: token('space.200'),
	},
});

const gridStylesLarge = cssMap({
	root: {
		width: '100%',
		gridTemplateColumns: '1fr 300px',
		gap: token('space.200'),
	},
});

type GridSize = 'small' | 'large';

const SmallGrid = (props: React.ComponentProps<typeof Grid>) => (
	<Grid {...props} xcss={gridStylesSmall.root} />
);

const LargeGrid = (props: React.ComponentProps<typeof Grid>) => (
	<Grid {...props} xcss={gridStylesLarge.root} />
);

type LayoutProps = {
	mainContent: React.ReactNode;
	mainContentHeader?: React.ReactNode;
	asideContent: React.ReactNode;
	rightColumnWidth?: GridSize;
};

export const Layout = ({
	mainContent,
	mainContentHeader,
	asideContent,
	rightColumnWidth = 'small',
}: LayoutProps) => {
	const GridComponent = rightColumnWidth === 'large' ? LargeGrid : SmallGrid;

	return (
		<GridComponent testId="questions-layout-grid">
			<Box padding="space.200">
				{mainContentHeader}
				{mainContent}
			</Box>
			<Box padding="space.200">{asideContent}</Box>
		</GridComponent>
	);
};
